/* CONIUNCTA Entwicklungsmuster im Warenkorb: Muster-Positionen (SKU-Suffix -EM) bleiben bei Menge 1.
   Plus/Minus der Zeile ausblenden, Eingabe sperren; wird trotzdem eine Menge > 1 gesetzt (Direkteingabe, Cart-API),
   wird die Zeile auf 1 zurueckgesetzt und der Warenkorb neu gerendert. Gehoert zu snippets/coni-em-cart.liquid
   (Custom-Liquid-Section in sections/footer-group.json, laeuft auf jeder Seite).
   Ein Muster je Kunde und Artikel (09.09.2026): Positionen, die Liquid als "bereits bestellt" markiert hat
   (<script data-coni-em-blocked>), werden entfernt; der Hinweis erscheint als Einblendung (nach Reload aus sessionStorage). */
(function () {
  'use strict';
  var SUFFIX = '-EM';
  var busy = false;
  function root() { return (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.root_url) || '/'; }
  function url(p) { var r = root(); return (r.endsWith('/') ? r.slice(0, -1) : r) + p; }
  function isSample(sku) { sku = String(sku || ''); return sku.length > SUFFIX.length && sku.slice(-SUFFIX.length) === SUFFIX; }
  function lockRows(cart) {
    var byVariant = {};
    (cart.items || []).forEach(function (it) { if (isSample(it.sku)) byVariant[String(it.variant_id)] = it; });
    Array.prototype.forEach.call(document.querySelectorAll('quantity-input.cart-quantity input[data-quantity-variant-id]'), function (inp) {
      var q = inp.closest('quantity-input');
      if (byVariant[String(inp.dataset.quantityVariantId)]) {
        inp.setAttribute('max', '1'); inp.setAttribute('readonly', 'readonly'); q.classList.add('coni-em-qty-locked');
      } else if (q.classList.contains('coni-em-qty-locked')) {
        inp.removeAttribute('max'); inp.removeAttribute('readonly'); q.classList.remove('coni-em-qty-locked');
      }
    });
    return byVariant;
  }
  function clamp(cart) {
    var over = (cart.items || []).filter(function (it) { return isSample(it.sku) && it.quantity > 1; });
    if (!over.length || busy) return;
    busy = true;
    var chain = Promise.resolve();
    over.forEach(function (it) {
      chain = chain.then(function () {
        return fetch(url('/cart/change.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: 1 })
        });
      });
    });
    chain.then(function () {
      busy = false;
      if (document.querySelector('main-cart')) { window.location.reload(); return; }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function () { busy = false; });
  }
  function handle(cart) {
    if (!cart || !cart.items) return;
    lockRows(cart);
    clamp(cart);
  }
  var TOAST_MS = 12000;
  function toast(msgs) {
    if (!msgs || !msgs.length) return;
    var el = document.createElement('div');
    el.className = 'coni-em-toast';
    el.setAttribute('role', 'status');
    msgs.forEach(function (m) { var p = document.createElement('p'); p.textContent = m; el.appendChild(p); });
    el.addEventListener('click', function () { if (el.parentNode) el.parentNode.removeChild(el); });
    document.body.appendChild(el);
    window.setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, TOAST_MS);
  }
  // Muster-Positionen von Artikeln entfernen, die der Kunde schon als Muster bestellt hat (Liste aus Liquid).
  function removeBlocked() {
    try {
      var pending = sessionStorage.getItem('coniEmRemoved');
      if (pending) { sessionStorage.removeItem('coniEmRemoved'); toast(JSON.parse(pending)); }
    } catch (e) { /* sessionStorage optional */ }
    var node = document.querySelector('script[data-coni-em-blocked]');
    var list = [];
    try { list = node ? (JSON.parse(node.textContent) || []) : []; } catch (e) { list = []; }
    if (!list.length || busy) return false;
    busy = true;
    var chain = Promise.resolve();
    list.forEach(function (b) {
      chain = chain.then(function () {
        return fetch(url('/cart/change.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: b.key, quantity: 0 })
        });
      });
    });
    chain.then(function () {
      busy = false;
      var msgs = list.map(function (b) { return b.message; });
      if (document.querySelector('main-cart')) {
        try { sessionStorage.setItem('coniEmRemoved', JSON.stringify(msgs)); } catch (e) { /* optional */ }
        window.location.reload();
        return;
      }
      toast(msgs);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      load();
    }).catch(function () { busy = false; });
    return true;
  }
  function load() {
    fetch(url('/cart.js'), { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(handle).catch(function () {});
  }
  try {
    if (window.FoxTheme && FoxTheme.pubsub && typeof FoxTheme.pubsub.subscribe === 'function') {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (e) {
        var d = e && e.data ? e.data : e;
        if (d && d.cart && d.cart.items) handle(d.cart); else load();
      });
    }
  } catch (e) { /* ohne pubsub: nur Initialpruefung */ }
  document.addEventListener('cart:updated', function (e) { if (e.detail && e.detail.cart) handle(e.detail.cart); else load(); });
  // Der Cart-Drawer wird beim Oeffnen/Aktualisieren neu gerendert: Sperre nach DOM-Aenderungen erneut setzen.
  var lastCart = null;
  var origHandle = handle;
  handle = function (cart) { lastCart = cart; origHandle(cart); };
  if (window.MutationObserver) {
    var drawer = document.querySelector('cart-drawer') || document.querySelector('main-cart');
    if (drawer) new MutationObserver(function () { if (lastCart) lockRows(lastCart); }).observe(drawer, { childList: true, subtree: true });
  }
  function start() { if (!removeBlocked()) load(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
